import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#3D2B1F] text-[#FDF8F0] relative overflow-hidden" data-id="element-114">
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#C8956C]/20 rounded-full blur-3xl" data-id="element-115" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-117">
          <SparklesIcon className="w-12 h-12 text-[#C8956C] mx-auto mb-6" data-id="element-118" />
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6" data-id="element-119">
            El Secreto: Sistema de Bombeo "Diamante"
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg md:text-xl leading-relaxed text-[#FAF3E8]/90 text-center max-w-3xl mx-auto" data-id="element-120">
          <p className="mb-6" data-id="element-121">
            A diferencia del masaje tradicional, el Drenaje Brasileño utiliza
            maniobras rítmicas de baja presión diseñadas específicamente para{' '}
            <strong data-id="element-122">"abrir" los ganglios inguinales y axilares</strong>,
            permitiendo que el exceso de líquido fluya hacia los canales de
            eliminación naturales de tu cuerpo.
          </p>
          <p className="text-[#C8956C] font-bold text-xl md:text-2xl italic font-heading" data-id="element-123">
            "Es como abrir el desagüe de una bañera tapada: una vez que liberas
            la salida, el líquido se va por sí solo, dejando una silueta
            esculpida y ligera."
          </p>
        </motion.div>
      </div>
    </section>;
}